var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-img',{attrs:{"src":("images/" + _vm.imgSource),"alt":"Photo"},on:{"click":function($event){return _vm.modalShow()}}}),_c('p',[_vm._v(_vm._s(_vm.EmpName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }